import gql from "graphql-tag";

export const addorEditCustomer = gql`
  mutation CustomersCreate($obj: JSON) {
    CustomersCreate(data: $obj) {
      id
    }
  }
`;

export const addorEditLinkedinProfile = gql`
  mutation CustomerlinkedinprofilesCreate($data: JSON) {
    CustomerlinkedinprofilesCreate(data: $data) {
      id
    }
  }
`;

export const updateCustomer = gql`
  mutation CustomersUpsertWithWhere($id: JSON, $data: JSON) {
    CustomersUpsertWithWhere(where: $id, data: $data) {
      id
    }
  }
`;

export const updateCustomerLinkedinCreate = gql`
  mutation CustomerlinkedinprofilesUpsertWithWhere($id: JSON, $data: JSON) {
    CustomerlinkedinprofilesUpsertWithWhere(where: $id, data: $data) {
      id
    }
  }
`;
